/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'project-panel.project-icon-header.update-error-description': '{projectName} のアイコンを更新できませんでした',
  'project-panel.project-icon-header.update-error-title': '問題が発生しました。',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'さらにフィールドを表示',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': '表示を減らす',
  'project-panel.project-panel-header.title': 'プロジェクト',
  'project-panel.project-panel-tabs.about-tab-title': '概要',
  'project-panel.project-panel-tabs.decisions-title': '決定事項',
  'project-panel.project-panel-tabs.learnings-title': 'ナレッジ',
  'project-panel.project-panel-tabs.risks-title': 'リスク',
  'project-panel.project-panel-tabs.updates-tab-title': '最新情報',
  'project-panel.project-title.edit-button-label': 'プロジェクト タイトルを編集',
  'project-panel.project-title.update-error-description': '{projectName} のコンテンツを更新できませんでした',
  'project-panel.project-title.update-error-title': '問題が発生しました',
  'project-panel.project-title.validation-message': 'プロジェクトのタイトルを指定してください',
};
